import { type PlanServicePlanComponents } from '@hungryroot/rest';
import {
  DINNER_STABLE_NAME_ID,
  LUNCH_STABLE_NAME_ID,
  MEALS_CONTAINER_ID,
  findPlanComponent,
} from '../utils/utils';

function findRecipeQuantityVersion(
  planComponents: PlanServicePlanComponents
): number | undefined {
  const dinnerComponent = findPlanComponent(
    planComponents.plan_components,
    DINNER_STABLE_NAME_ID
  );

  const lunchComponent = findPlanComponent(
    planComponents.plan_components,
    LUNCH_STABLE_NAME_ID
  );

  const lunchDinnerVersion =
    dinnerComponent?.pricing_configurations.RECIPE_QUANTITY?.version ||
    lunchComponent?.pricing_configurations.RECIPE_QUANTITY?.version;

  if (lunchDinnerVersion !== undefined) {
    return lunchDinnerVersion;
  }

  for (const component of planComponents.plan_components) {
    const version = component.pricing_configurations.RECIPE_QUANTITY?.version;

    if (version !== undefined) {
      return version;
    }
  }

  return undefined;
}

// Meals (13) only exists on V33, so it identifies a V33 plan that has no
// recipe containers left (Exp 220 allows 0 Lunch and 0 Dinner). Other TIERED
// containers are not used: their version can lag the plan's recipe pricing.
function findMealsVersion(
  planComponents: PlanServicePlanComponents
): number | undefined {
  return planComponents.plan_components.find(
    (component) => component.container_id === MEALS_CONTAINER_ID
  )?.pricing_configurations.TIERED?.version;
}

export function getPricingVersionFromPlanComponents(
  planComponents: PlanServicePlanComponents,
  fallbackPlanComponents?: PlanServicePlanComponents
) {
  return (
    findRecipeQuantityVersion(planComponents) ??
    (fallbackPlanComponents &&
      findRecipeQuantityVersion(fallbackPlanComponents)) ??
    findMealsVersion(planComponents) ??
    (fallbackPlanComponents && findMealsVersion(fallbackPlanComponents)) ??
    0
  );
}

export function getRecipeQuantityServingSizeFromPlanComponents(
  planComponents: PlanServicePlanComponents,
  fallbackPlanComponents?: PlanServicePlanComponents
) {
  const containerWithServingSize = planComponents.plan_components.find(
    (component) => component.container_pricing_strategy === 'RECIPE_QUANTITY'
  );

  const servingSize =
    containerWithServingSize?.pricing_configurations.RECIPE_QUANTITY
      ?.serving_size;

  if (servingSize !== undefined) {
    return servingSize;
  }

  if (fallbackPlanComponents !== undefined) {
    return getRecipeQuantityServingSizeFromPlanComponents(
      fallbackPlanComponents
    );
  }

  return undefined;
}
